import { tokens } from 'src/design-system';

const styles = theme => ({
  emptyPageParentDiv: {
    height: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyPageContentDiv: {
    marginTop: tokens.spacing.md,
    color: '#666666',
    fontFamily: 'Open Sans',
    fontSize: '18px',
    fontWeight: tokens.fontWeight.semibold,
    textAlign: 'center',
  },
  cardParentDiv: {
    paddingLeft: 20,
    paddingBottom: tokens.spacing.lg,
    position: 'relative',
  },
  blueCircle: {
    position: 'absolute',
    left: '-10px',
    height: '18px',
    width: '18px',
    borderRadius: '15px',
    background: tokens.colors.primaryDark,
    zIndex: tokens.zIndex.sticky,
    border: `2px solid ${tokens.colors.bgWhite}`,
  },
  activityNameDiv: {
    display: 'flex',
    color: tokens.colors.text,
    fontFamily: "Open Sans",
    fontSize: tokens.fontSize.small,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: 1.5,
    paddingBottom: tokens.spacing.ms,
  },
  activityMetaContentDiv: {
    color: '#666666',
    fontFamily: "Open Sans",
    fontWeight: tokens.fontWeight.regular,
    fontSize: tokens.fontSize.small,
    marginLeft: tokens.spacing.sm,
  },
  activityCreatorNameDiv: {
    color: '#111',
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: 1,
  },
  activityOrgNameDiv: {
    color: '#666666',
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.regular,
    fontStyle: 'italic',
    lineHeight: 1,
  },
  activityCreatedAtDiv: {
    marginLeft: tokens.spacing.ms,
    color: '#999999',
    fontWeight: tokens.fontWeight.semibold,
    fontSize: 8,
    fontFamily: 'Open Sans',
  },
  activityContentDiv: {
    color: '#111',
    fontSize: tokens.fontSize.small,
    fontFamily: 'Open Sans',
    lineHeight: 1,
  },
  activityBlock: {
    width: 'fit-content',
    backgroundColor: '#FCFAF4',
    borderRadius: tokens.radius.md,
    padding: `10px ${tokens.spacing.ms}px ${tokens.spacing.ms}px`,
  },
  activityBlockHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: tokens.spacing.ms,
  },
});

export default styles;
